module.exports = __webpack_public_path__ + "static/img/aixy1.c3ce75f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/aixy1.png
// module id = q/D3
// module chunks = 0